import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { Homepage } from './Homepage'
import { Placeholder } from './Placeholder'
import './home.css'

const container = document.getElementById('root')
if (!container) throw new Error('Root element missing from index.html')

// __HOMEPAGE_ENABLED__ is replaced with a literal true or false at build time
// (see vite.config.ts), so the branch not taken is dropped from the bundle
// entirely, along with everything only it imports.
createRoot(container).render(
  <StrictMode>{__HOMEPAGE_ENABLED__ ? <Homepage /> : <Placeholder />}</StrictMode>,
)
